import React from 'react';

function SocialMediaPageHeader() {
  return (
    <>
      <section className="page-header" style={{ backgroundImage: 'url(assets/img/page-banner.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>

        <div className="container">
          <div className="page-header-info">
            <h2>
              <span>Social Media</span>
            </h2>
          </div>
        </div>
      </section>
    </>

  );
}

export default SocialMediaPageHeader;

